const Footer = () => {
  return (
    <footer className="p-2 self-end bg-[#eff8ff] w-full mt-auto">
      <div className="flex gap-y-3 flex-wrap justify-between font-sm text-sm lg:text-base">
        <span>
          COPYRIGHT © 2025 <a href="https://polarisgrids.com/">Polaris</a>, All
          rights Reserved
        </span>
        <span>
          Dashboard Version: 1.0.9 | Backend Version: 2.1.4 | HES Version: 2.0.6
        </span>
      </div>
    </footer>
  );
};

export default Footer;
